import { Badge, Button } from '@design-system';
import { ChevronLeft, Sparkles } from 'lucide-react';

import { TierCard } from './tier-card';

import type { FreemiumTier, FreemiumTierConfig } from '@shared';

interface UsagePaywallProps {
  tiers: FreemiumTierConfig[];
  onSelectTier: (tier: FreemiumTier) => void;
  onBack: () => void;
  isPending: boolean;
  pendingTier?: FreemiumTier;
}

export function UsagePaywall({
  tiers,
  onSelectTier,
  onBack,
  isPending,
  pendingTier,
}: UsagePaywallProps) {
  const columns = tiers.length >= 4 ? 'lg:grid-cols-4' : 'md:grid-cols-3';

  return (
    <div className="mx-auto w-full max-w-6xl">
      <div className="flex flex-col items-center gap-4 text-center">
        <Badge>
          <Sparkles />
          Pick how you want to plan
        </Badge>
        <h1 className="text-balance text-3xl font-bold text-gray-950">
          Explore Waterlily planning options
        </h1>
        <p className="text-foreground max-w-xl text-balance">
          Complete your plan on your own, with some help, or let us do it all. It&apos;s all we do.
        </p>
      </div>

      <div className={`mt-12 grid items-stretch gap-6 ${columns}`}>
        {tiers.map(config => (
          <TierCard
            key={config.tier}
            config={config}
            isPending={isPending}
            isLoading={pendingTier === config.tier}
            onSelect={() => onSelectTier(config.tier)}
          />
        ))}
      </div>

      <div className="mt-6">
        <Button
          variant="outline"
          onClick={onBack}
          disabled={isPending}
        >
          <ChevronLeft />
          Back
        </Button>
      </div>
    </div>
  );
}
